import {ALL_OPTION} from '@/constants';
import {
  FootTrafficAgeGroup,
  FootTrafficGender,
  FootTrafficTimeCode,
  FootTrafficVarTypes as Variables,
  FootTrafficWeekAgeTimeDayType,
} from '../enums';

export const FOOT_TRAFFIC_OPT_LABELS = {
  [Variables.gender]: '성별',
  [Variables.age]: '나이',
  [Variables.day]: '요일',
  [Variables.time]: '시간',
};

export const FOOT_TRAFFIC_OPTIONS = {
  [Variables.gender]: [
    ALL_OPTION,
    {id: FootTrafficGender.m, label: '남성'},
    {id: FootTrafficGender.w, label: '여성'},
  ],
  [Variables.age]: [
    ALL_OPTION,
    {id: FootTrafficAgeGroup.AG10 as string, label: '10대'},
    {id: FootTrafficAgeGroup.AG20 as string, label: '20대'},
    {id: FootTrafficAgeGroup.AG30 as string, label: '30대'},
    {id: FootTrafficAgeGroup.AG40 as string, label: '40대'},
    {id: FootTrafficAgeGroup.AG50 as string, label: '50대'},
    {id: FootTrafficAgeGroup.AG60 as string, label: '60대 이상'},
  ],
  [Variables.day]: [
    {id: FootTrafficWeekAgeTimeDayType.W as string, label: '평일'},
    {id: FootTrafficWeekAgeTimeDayType.H as string, label: '주말'},
  ],
  [Variables.time]: [
    ALL_OPTION,
    {id: FootTrafficTimeCode.T6_10, label: '오전'},
    {id: FootTrafficTimeCode.T11_14, label: '점심'},
    {id: FootTrafficTimeCode.T15_17, label: '오후'},
    {id: FootTrafficTimeCode.T18_20, label: '저녁'},
    {id: FootTrafficTimeCode.T21_00, label: '밤'},
  ],
};

export const FOOTTRAFFIC_TOP_PERCENTAGE = [5, 10, 30, 50];
export const FOOT_TRAFFIC_LIMIT_RADIUS = 1_000;
export const FOOT_TRAFFIC_LIMIT_AREA = 3_000_000;
